import { render, staticRenderFns } from "./CertificateRegistration.vue?vue&type=template&id=ace46d88&scoped=true&lang=pug&"
import script from "./CertificateRegistration.vue?vue&type=script&lang=ts&"
export * from "./CertificateRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateRegistration.vue?vue&type=style&index=0&id=ace46d88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace46d88",
  null
  
)

export default component.exports